import React, {useEffect, useState} from 'react';
import {useForm} from "react-hook-form";
import {Markup} from 'interweave';
import apiFetch from '@wordpress/api-fetch';
import {__} from '@wordpress/i18n';

const App = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formAlert, setFormAlert] = useState({class: '', message: ''});
  const {register, handleSubmit, setValue, formState: {errors}} = useForm();

  const onSubmit = (formData) => {
    if (!isSubmitting) {
      sendFormData(formData);
    }
  }

  const sendFormData = (formData) => {
    setIsSubmitting(true);

    apiFetch({
      path: tanecniskola.api_path + '/form/contact/',
      method: 'POST',
      data: formData,
    })
      .then((response) => {
        let formAlert;
        if (response.code) {
          formAlert = {
            class: 'error',
            message: response.message
          };
        } else {
          formAlert = {
            class: '',
            message: response.message
          };
          formAlert.class = (response.success) ? 'success' : 'error';
        }
        setFormAlert(formAlert);
        setIsSubmitting(false);
      });
  };

  return (
    <form method="POST" onSubmit={handleSubmit(onSubmit)}>
      <header className="form__header">
        <div className="form__title">{__('Máte dotaz?', 'tanecniskola')}</div>
        <h2>{__('Napište nám', 'tanecniskola')}</h2>

        {'' !== formAlert.message && 'error' !== formAlert.class &&
          <div className={`alert alert--${formAlert.class}`}>
            <p>{formAlert.message}</p>
          </div>
        }
      </header>

      {'' === formAlert.message &&
        <>
          <div className="form__row">
            <div className="form__column">
              <div className="form__item">
                <label className="form__label" htmlFor="name">{__('Jméno', 'tanecniskola')}</label>
                <input id="name" {...register("name", {
                  required: __('Toto pole je povinné.', 'tanecniskola'),
                })} />
                {errors.name && <div className="form__error">{errors.name.message}</div>}
              </div>
            </div>
            <div className="form__column">
              <div className="form__item">
                <label className="form__label" htmlFor="surname">{__('Příjmení', 'tanecniskola')}</label>
                <input id="surname" {...register("surname", {
                  required: __('Toto pole je povinné.', 'tanecniskola'),
                })} />
                {errors.surname && <div className="form__error">{errors.surname.message}</div>}
              </div>
            </div>
          </div>

          <div className="form__row">
            <div className="form__column">
              <div className="form__item">
                <label className="form__label" htmlFor="phone">{__('Telefon', 'tanecniskola')}</label>
                <input type="tel" id="phone"
                       {...register("phone", {
                         pattern: {
                           value: /^(\+420|\+421|00420|00421)?[ ]*[0-9]{3}[ ]*[0-9]{3}[ ]*[0-9]{3}$/,
                           message: __('Zadejte validní telefonní číslo.', 'tanecniskola')
                         }
                       })} />
                {errors.phone && <div className="form__error">{errors.phone.message}</div>}
              </div>
            </div>
            <div className="form__column">
              <div className="form__item">
                <label className="form__label" htmlFor="email">{__('E-mail', 'tanecniskola')}</label>
                <input type="email" id="email"
                       {...register("email", {
                         required: __('Toto pole je povinné.', 'tanecniskola'),
                         pattern: {
                           value: /\S+@\S+\.\S+/,
                           message: __('Zadejte validní e-mailovou adresu.', 'tanecniskola')
                         }
                       })} />
                {errors.email && <div className="form__error">{errors.email.message}</div>}
              </div>
            </div>
          </div>

          <div className="form__row">
            <div className="form__column">
              <div className="form__item">
                <label className="form__label" htmlFor="message">{__('Vaše zpráva', 'tanecniskola')}</label>
                <textarea id="message"
                          {...register("message", {
                            required: __('Toto pole je povinné.', 'tanecniskola'),
                          })}></textarea>
                {errors.message && <div className="form__error">{errors.message.message}</div>}
              </div>
            </div>
          </div>

          <footer className="form__footer">
            <div className="form__terms">
              <Markup content={tanecniskola_form.terms_label} noWrap={true}/>
            </div>

            {'' !== formAlert.message && 'error' === formAlert.class &&
              <div className="form__error">{formAlert.message}</div>
            }

            <div className="form__button">
              <button type="submit" className="button button--green">
              <span>{
                (isSubmitting) ? (
                  __('Odesílám formulář...', 'tanecniskola')
                ) : (
                  __('Odeslat dotaz', 'tanecniskola')
                )
              }</span>
              </button>
            </div>
          </footer>
        </>
      }
    </form>
  );
}

document.addEventListener("DOMContentLoaded", function (event) {
  const items = document.querySelectorAll('.app-form-contact');
  if (items) {
    items.forEach(item => {
      ReactDOM.render(<App/>, item)
    });
  }
});
